import axios from 'axios'
import config from './config.js'
import Toast from '../components/toast/index.js'

// 默认参数
let params = {
  siteCode: config.testSiteCode ? config.testSiteCode : config.siteCode, // 判断是否存在测试站点信息 如果没有则用正式接口
  lang: config.lang
}
// 测试接口地址
let TestApiUrl = {
  default: 'http://ptisp.test.daqsoft.com/scapi/api/scapi/app/',
  baseElectricity: 'http://ptisp.test.daqsoft.com/dsapi/api/ds/',
  aliPay: 'http://ptisp.test.daqsoft.com/dsapi/api/ds/qiandnApi/payment-pc/submit.jhtml'
}

// ajax方法
export default function ajax (p) {
  let c = Object.assign({
    url: '',
    type: 'GET',
    params: {},
    loading: true,
    token: false,
    siteCode: false,
    serviceUrl: 'default'
  }, p)
  return new Promise((resolve, reject) => {
    let t = null
    let timmer = null
    // 判断是否有加载
    if (c.loading) {
      t = Toast({
        type: 'loading',
        message: '数据加载中...',
        duration: 5000
      })
      if (timmer) {
        clearTimeout(timmer)
      }
    }
    // 判断是不是测试接口
    let API
    if (config.testSiteCode) {
      // 使用测试接口
      API = ['default', 'baseElectricity', 'aliPay'].indexOf(c.serviceUrl) !== -1 ? TestApiUrl[c.serviceUrl] : alert('你请求的服务器地址错误，请检查')
    } else {
      // 使用正式接口
      API = ['default', 'baseElectricity', 'aliPay'].indexOf(c.serviceUrl) !== -1 ? config[c.serviceUrl] : alert('你请求的服务器地址错误，请检查')
    }
    axios({
      method: c.type,
      url: c.url.indexOf('http') !== -1 ? c.url : API + c.url,
      params: Object.assign(c.params, params)
    }).then((response) => {
      if (c.loading) {
        t.show = false
      }
      if (response.data.code === 2) {
      } else {
        resolve(response.data)
      }
    }).catch((error) => {
      if (c.loading) {
        t.type = 'error'
        t.message = '服务器错误'
        timmer = setTimeout(() => {
          t.show = false
        }, 1000)
      }
      reject(error)
    })
  })
}



// WEBPACK FOOTER //
// ./src/service/fetch.js